import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
// import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomeStartUp from "./pages";
import CustomCursor from "components/common/custom-cursor";
// import HomeStartupBanner from "pages/HomeStartupBanner";
// import HomeStartupBanner from "@components/hero-banners/HomeStartupBanner";

// Keep the landing page in the entry bundle and load every other page only when
// its route is requested. This preserves each page while reducing initial JS.
const AboutMe = lazy(() => import("pages/about"));
const ErrorPage = lazy(() => import("pages/404"));
const Contact = lazy(() => import("pages/contact"));
const Services = lazy(() => import("pages/services"));
const ComingSoon = lazy(() => import("pages/ComingSoon"));
const Careers = lazy(() =>
  import("pages/Careers").then((module) => ({ default: module.Careers }))
);
const Services2D = lazy(() => import("pages/Service2d"));
const GameDevelopment = lazy(() => import("pages/GameDevelopment"));
const Ghar360 = lazy(() => import("pages/Ghar360"));
const Ghar360WebDemoLogin = lazy(() => import("pages/Ghar360WebDemoLogin"));
const ThreeDProducts = lazy(() => import("pages/ThreeDProducts"));
const BVM2026 = lazy(() => import("pages/BVM2026"));
const BVM2026Admin = lazy(() => import("pages/BVM2026Admin"));
const PortfolioDashboard = lazy(() => import("pages/PortfolioDashboard"));
const DigitalMarketing = lazy(() => import("pages/DigitalMarketing"));
const InteriorDesigning = lazy(() => import("pages/ServiceInteriorDesigning"));
const Policy = lazy(() => import("pages/Policy"));
const Blog = lazy(() => import("pages/Blog"));
const NFT = lazy(() => import("pages/NFT"));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <CustomCursor />
      <Suspense fallback={null}>
        <Routes>
          <Route exact path="/" element={<HomeStartUp />}></Route>
          <Route exact path="/ghar360" element={<Ghar360 />}></Route>
          <Route exact path="/ghar360-web-interactive-walkthough-demo" element={<Ghar360WebDemoLogin />}></Route>
          <Route exact path="/3D_Products" element={<ThreeDProducts />}></Route>
          <Route exact path="/3D_Products/embed/:productId" element={<ThreeDProducts />}></Route>
          <Route exact path="/BVM2026" element={<BVM2026 />}></Route>
          <Route exact path="/BVM2026/admin" element={<BVM2026Admin />}></Route>
          <Route exact path="/portfolio-dashboard" element={<PortfolioDashboard />}></Route>
          <Route exact path="/about-us" element={<AboutMe />}></Route>
          <Route exact path="/contact-us" element={<Contact />}></Route>
        <Route
          exact
          path="/best-3d-services-india"
          element={<Services />}
        ></Route>
        <Route
          exact
          path="/graphic-designing-services-india"
          element={<Services2D />}
        ></Route>
        <Route
          exact
          path="/viral-cgi-videos"
          element={<NFT/>}
        ></Route>
        <Route
          exact
          path="/best-digital-marketing-services-india"
          element={<DigitalMarketing />}
        ></Route>
        <Route
          exact
          path="/best-interior-designing-india"
          element={<InteriorDesigning />}
        ></Route>
        <Route path="/shop/:id?" element={<Blog />}></Route>
        <Route
          exact
          path="/game-development-services-india"
          element={<GameDevelopment />}
        ></Route>
        <Route
          exact
          path="/best-web-development-services-india"
          element={<GameDevelopment />}
        ></Route>
        <Route
          exact
          path="/3d-space-announcement"
          element={<ComingSoon />}
        ></Route>
        {/* <Route
          exact
          path="/blogs"
          element={<HomeStartupBanner />}
        ></Route> */}
        <Route exact path="/Careers" element={<Careers />}></Route>
        <Route exact path="/privacy-policy" element={<Policy />}></Route>

          <Route path="*" element={<ErrorPage />}></Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
